/** Scenario vs current-actual gross margin copy. Does not change projection math. */

export const SCENARIO_BASE_GM_ASSUMPTION_PCT = "16.2";

/** Snapshot stores 21.78; some payloads may send 0.2178. */
export function normalizeGrossMarginPct(raw) {
  const n = Number(raw);
  if (!Number.isFinite(n) || n <= 0) return null;
  return n <= 1 ? n * 100 : n;
}

export function formatScenarioGrossMarginPresentation(actualPct) {
  const actual = normalizeGrossMarginPct(actualPct);
  return {
    inputLabel: "Scenario GM assumption",
    assumptionPct: SCENARIO_BASE_GM_ASSUMPTION_PCT,
    actualDisplay:
      actual != null ? `Current actual ${actual.toFixed(2)}%` : "",
    kpiLabel: "Scenario gross margin",
    kpiNote: "Assumption · not current actual",
    labelsActual: false,
  };
}
